export const AOSchedulePeriodName = (): { ['1']: string, ['2']: string, ['3']: string } => ({
  ['1']: 'Seasonal',
  ['2']: 'Max',
  ['3']: 'Last X Months',
});